export default __webpack_public_path__ + "static/media/playpause_icon.98ef7258.svg";